
<!-- 

EFETUA AJUSTE NA QUANTIDADE DO PRODUTO
ROTINA UTILIZADA NO APP FORCA DE VENDAS PARA AJUSTE DAS QUANTIDADES DE ESTOQUE

estoque/atualizaquantidade/

 -->


<script>

import BarList from '../components/bar-list'
import { apiORDS, apiORDSpost } from '../shared/api-functions'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: false,
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        produtos: function () {
            return this.$store.getters.getItemSalesList
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },

    },

    methods: {
        handleFocusProduto (produto, grade) {
            if (grade) 
              grade.saldo_estoque_anterior = grade.saldo_estoque
            else
              produto.saldo_estoque_anterior = produto.saldo_estoque
        },

        async updateQuantidade (produto, grade) {
            //EFETUA A ATUALIZACAO DA QUANTIDADE INFORMADA
            console.log(grade)
            if (grade && grade.saldo_estoque && grade.saldo_estoque != grade.saldo_estoque_anterior) {
                let sendData = { coditemgrade: grade.coditemgrade, qt: grade.saldo_estoque }
                const data = await apiORDSpost(this.$store, 'estoque/atualizaquantidade/', sendData, 'post')
            }
            if (!grade && produto.saldo_estoque && produto.saldo_estoque != produto.saldo_estoque_anterior) {
                let sendData = { coditem: produto.coditem, qt: produto.saldo_estoque }
                const data = await apiORDSpost(this.$store, 'estoque/atualizaquantidade/', sendData, 'post')
            }
        },

        handleMore () {
            this.offset = true
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        textST (value) {
            return getText(value, this.metadata.item.stitem)
        },

        async loadData() {
            await this.$store.dispatch('loadTabpre', {}) 

            let params = { filter: this.filter }
            if (this.offset) {
                params.offset = this.nextPage
            }
            this.$store.dispatch('loadPesquisaProdutosSales', params )
            this.offset = false
        },

        async loadGrade(produto) {
            if (produto.showGrade) {
                produto.showGrade = false
                return
            }
            var url = 'item/sales/pesquisa/produtos/' + produto.coditem + '/grade'
            const data = await apiORDS(this.$store.getters.urlOrds + url, {})
            if (data.items) {
                this.$set(produto, 'showGrade', true)
                this.$set(produto, 'grade', data.items)
            }
        },

    },

    components: {
        BarList
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
<div id="list"> 
    <bar-list
        :refresh-button="true" 
        :xls-button="true"
        single-entity="" 
        plural-entity="Saldos de Estoque"
        @search="search"
        @refresh="loadData"
        title-search="Pesquise pelo código ou pela descrição do produto">
    </bar-list>

    <div class="default-container nb-card-list">
        <alert v-if="produtos.length == 0" type="norecord"></alert>

        <article class="nb-card" v-for="(produto, index) in produtos" :key="produto.coditem || index">
            <div class="nb-card-top">
                <div class="nb-card-identity">
                    <div class="nb-card-image">
                        <img v-if="produto.url" :src="produto.url" alt="">
                        <i v-else class="fa fa-camera" aria-hidden="true"></i>
                    </div>

                    <div class="nb-card-title">
                        <div class="nb-card-title-line">
                            <h2>{{ produto.descricao }}</h2>
                            <span v-if="produto.isgrade == 'S'" class="nb-card-badge nb-card-badge--info">
                                Grade
                            </span>
                        </div>
                        <div class="nb-card-code">
                            Código <strong>{{ produto.codigo || '—' }}</strong>
                        </div>
                    </div>
                </div>

                <div class="nb-card-actions">
                    <div v-if="produto.isgrade == 'S'">
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="loadGrade(produto)">
                            <i class="fa fa-th fa-fw"></i>
                            <span class="ml-1">{{ produto.showGrade ? 'Ocultar Grades' : 'Ver Grades' }}</span>
                        </button>
                    </div>
                    <div v-else class="d-flex align-items-center">
                        <span class="nb-stock-label mr-2">Saldo:</span>
                        <input-number class="form-control form-control-sm nb-stock-input" v-model="produto.saldo_estoque" @blur="updateQuantidade(produto)" @focus="handleFocusProduto(produto)"></input-number>
                    </div>
                </div>
            </div>

            <div class="nb-card-subitems" v-if="produto.showGrade && produto.grade && produto.grade.length">
                <div class="nb-card-subitem" v-for="(grade, gIdx) in produto.grade" :key="gIdx">
                    <div class="nb-card-subitem-top">
                        <div class="nb-card-subitem-identity">
                            <i class="fa fa-level-up fa-rotate-90 nb-subitem-arrow" aria-hidden="true"></i>
                            <span class="nb-subitem-title">{{ grade.linha }} <small v-if="grade.coluna">/ {{ grade.coluna }}</small></span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="nb-stock-label mr-2">Saldo:</span>
                            <input-number class="form-control form-control-sm nb-stock-input" v-model="grade.saldo_estoque" @blur="updateQuantidade(produto, grade)" @focus="handleFocusProduto(produto, grade)"></input-number>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <div class="text-center my-3" v-if="nextPage > 0">
            <button class="btn btn-outline-primary btn-sm" @click="handleMore()">
                <i class="fa fa-chevron-down mr-1"></i> Exibir mais produtos
            </button>
        </div>
    </div>
</div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-image {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.nb-card-image > img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nb-card-image > .fa {
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--info {
  color: #0369a1;
  background: #f0f9ff;
  border-color: #bae6fd;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-stock-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
}

.nb-stock-input {
  width: 110px;
  text-align: right;
  font-weight: 600;
}

.nb-card-subitems {
  margin-top: 12px;
  margin-left: 24px;
  padding-left: 16px;
  border-left: 2px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nb-card-subitem {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
}

.nb-card-subitem-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.nb-card-subitem-identity {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
}

.nb-subitem-arrow {
  color: #94a3b8;
  font-size: 14px;
}

.nb-subitem-title {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-start;
  }

  .nb-card-subitems {
    margin-left: 10px;
    padding-left: 10px;
  }
}
</style>








// WEBPACK FOOTER //
// src/forms/item-ajuste-estoque.vue